'use client'

import { cn } from '@/utils/common'

interface LoadingCardProps {
  className?: string
}

export default function LoadingCard({ className }: LoadingCardProps) {
  return (
    <div className={cn('flex flex-col items-center justify-center py-12', className)}>
      <div className="h-8 w-8 animate-spin rounded-full border-4 border-indigo-200 border-t-indigo-600"></div>
      <p className="mt-4 text-gray-500">Ładowanie...</p>
    </div>
  )
}
